import {ChangeDetectorRef, Component} from '@angular/core';
import {DeviceEventService} from "../../services/device-event.service";
import {AbstractProdGrid, IProdGrid, ProdGridColumnTransforms, ProdGridColumnType} from 'prod-grid';
import {DipColumn} from "../../dip/dip-column";
import {BatteryEventTypeService} from "../../services/battery-event-type.service";
import {DeviceTypeService} from "../../services/device-type.service";
import {DevicesService} from "../../services/devices.service";
import {OrganizationTreeSelect} from "../../dip/organization-tree-select";
import {HttpExtraParams} from "prod-shared";
import {Role} from "../../dip/role";
import {AuthenticationService} from "../../services/authentication.service";
import {User} from "../../models/user";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-device-events',
  templateUrl: './device-events.component.html'
})
export class DeviceEventsComponent extends AbstractProdGrid implements IProdGrid {
  prodGridTitle: string = this.translate.instant('device_events.grid_title');
  prodGridColumns: DipColumn[] = [
    DipColumn.get({property: 'id', type: ProdGridColumnType.ID}),
    DipColumn.get({
        property: 'device.deviceType.name', type: ProdGridColumnType.SELECT_COMPONENT,
        selectParameters: {
          selectDataService: DeviceTypeService,
          isComplete: true,
          isMulti: true,
          isNarrowDown: true
        },
        isEnum: true
      }
    ),
    DipColumn.get({
      property: 'type.name', type: ProdGridColumnType.SELECT_COMPONENT,
      selectParameters: {
        selectDataService: BatteryEventTypeService,
        isComplete: true,
        isNarrowDown: true,
        isMulti: true
      },
      isEnum: true
    }),
    DipColumn.get({
        property: 'device.name', type: ProdGridColumnType.SELECT_COMPONENT,
        selectParameters: {
          selectDataService: DevicesService,
          isMulti: true,
          isComplete: true,
          isNarrowDown: true
        }
      }
    ),
    DipColumn.get({
      property: 'createdAt',
      type: ProdGridColumnType.DATE,
      transform: {
        transform: ProdGridColumnTransforms.DATETIME
      }
    }),
    DipColumn.get({
      property: 'batteryEvent.voltage',
      type: ProdGridColumnType.NUMBER,
      postfix: 'V',
      transform: {transform: ProdGridColumnTransforms.ZERO_PADDING, option: 3}
    }),
    DipColumn.get({
      property: 'batteryEvent.warned',
      type: ProdGridColumnType.ICON,
      transform: {
        transform: ProdGridColumnTransforms.BATTERY_WARN_ICON
      },
      isEnum: true
    }),
    DipColumn.get({
      property: 'batteryEvent.alerted',
      type: ProdGridColumnType.ICON,
      transform: {
        transform: ProdGridColumnTransforms.BATTERY_ALERT_ICON
      },
      isEnum: true
    }),
    DipColumn.get({
      property: 'batteryEvent.vin',
      type: ProdGridColumnType.STRING
    }),
    DipColumn.get({
      property: 'batteryEvent.numberPlate',
      type: ProdGridColumnType.STRING
    })
  ];
  user: User;

  constructor(
    protected override changeDetectorRef: ChangeDetectorRef,
    override prodGridDataService: DeviceEventService,
    private organizationTreeSelect: OrganizationTreeSelect,
    private authService: AuthenticationService,
    private translate: TranslateService) {
      super(changeDetectorRef);
      organizationTreeSelect.gridComponent = this;
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.user = this.authService.currentUserValue;
    this.setColumns();
  }

  ngOnDestroy() {
    this.organizationTreeSelect.gridComponent = null;
  }

  override loadProdGridData(httpExtraParams?: HttpExtraParams): void {
    super.loadProdGridData(HttpExtraParams.addFilter(httpExtraParams, this.organizationTreeSelect.getHttpExtraParams(this.prodGridDataService)));
  }

  setColumns() {
    const user = this.user;
    const company = this.organizationTreeSelect.company;
    if (!user || !company) return;
    if (!user.roles.includes(Role.ROLE_SYS) && !user.organizationStatus[company.id]) {
      this.prodGridColumns.forEach(col => {
        if (['batteryEvent.vin', 'batteryEvent.numberPlate'].indexOf(col.dataProperty) !== -1) col['format'] = ProdGridColumnType.HIDDEN;
      })
    } else {
      this.prodGridColumns.forEach(col => {
        if (['batteryEvent.vin', 'batteryEvent.numberPlate'].indexOf(col.dataProperty) !== -1) col['format'] = ProdGridColumnType.STRING;
      })
    }
  }
}
